import { z } from 'zod/v4';

/** One selectable facility process — `key`/`text` is the dropdown option shape. */
export const FacilityProcessDropdownOptionSchema = z.object({
  key: z.string(),
  text: z.string(),
});

export type FacilityProcessDropdownOption = z.infer<
  typeof FacilityProcessDropdownOptionSchema
>;

/** A production process and the facility processes grouped under it. */
export const FacilityProcessDropdownGroupSchema = z.object({
  productionProcessId: z.string(),
  productionProcessName: z.string(),
  children: z.array(FacilityProcessDropdownOptionSchema),
});

export type FacilityProcessDropdownGroup = z.infer<
  typeof FacilityProcessDropdownGroupSchema
>;

// The `data` payload; the route wraps it in the standard `{ data, metadata }`
// envelope.
export const FacilityProcessesDropdownResponseSchema = z.array(
  FacilityProcessDropdownGroupSchema,
);

export type FacilityProcessesDropdownResponse = z.infer<
  typeof FacilityProcessesDropdownResponseSchema
>;
